import type {
  ClientDetails,
  CreateClientRequest,
  CreateDeliveryAddressRequest,
  DeliveryAddress,
  ListClientsQuery,
  ListClientsResponse,
  UpdateClientRequest,
  UpdateDeliveryAddressRequest,
} from '@kreart/shared';
import { api } from '@/lib/api';

export function serialiseListQuery(query: ListClientsQuery): string {
  const p = new URLSearchParams();
  if (query.page !== 1) p.set('page', String(query.page));
  if (query.pageSize !== 25) p.set('pageSize', String(query.pageSize));
  if (query.search) p.set('search', query.search);
  if (query.includeDeleted) p.set('includeDeleted', 'true');
  const qs = p.toString();
  return qs ? `?${qs}` : '';
}

export const clientsApi = {
  list: (query: ListClientsQuery) =>
    api.get<ListClientsResponse>(`/clients${serialiseListQuery(query)}`),
  get: (id: string) => api.get<ClientDetails>(`/clients/${id}`),
  create: (body: CreateClientRequest) => api.post<ClientDetails>('/clients', body),
  update: (id: string, body: UpdateClientRequest) =>
    api.patch<ClientDetails>(`/clients/${id}`, body),
  remove: (id: string) => api.delete<void>(`/clients/${id}`),

  listAddresses: (id: string) => api.get<DeliveryAddress[]>(`/clients/${id}/delivery-addresses`),
  createAddress: (id: string, body: CreateDeliveryAddressRequest) =>
    api.post<DeliveryAddress>(`/clients/${id}/delivery-addresses`, body),
  updateAddress: (id: string, addressId: string, body: UpdateDeliveryAddressRequest) =>
    api.patch<DeliveryAddress>(`/clients/${id}/delivery-addresses/${addressId}`, body),
  removeAddress: (id: string, addressId: string) =>
    api.delete<void>(`/clients/${id}/delivery-addresses/${addressId}`),
};
